import { render, staticRenderFns } from "./revenue-sharing-settlement.vue?vue&type=template&id=8e9ffa94&scoped=true&"
import script from "./revenue-sharing-settlement.vue?vue&type=script&lang=js&"
export * from "./revenue-sharing-settlement.vue?vue&type=script&lang=js&"
import style0 from "./revenue-sharing-settlement.vue?vue&type=style&index=0&id=8e9ffa94&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e9ffa94",
  null
  
)

export default component.exports